"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTenancyFromEmailAddress = void 0;
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const removeTenancyFromEmailAddress = (email) => email.includes("\\") ? email.split("\\")[1] : email;
exports.removeTenancyFromEmailAddress = removeTenancyFromEmailAddress;
//# sourceMappingURL=index.js.map